import useTableHiddenColumns from '@resources/js/contexts/useTableHiddenColumns';
import Body from '@resources/js/components/Body/Body';
import HorizontalContent from '@resources/js/components/HorizontalContent/HorizontalContent';
import Toggle from '@resources/js/components/Toggle/Toggle';
import React, { useEffect } from 'react';
import Heading from '@resources/js/components/Heading/Heading';
import Tooltip from '@resources/js/components/Tooltip/Tooltip';
import VerticalContent from '@resources/js/components/VerticalContent/VerticalContent';
import useLocalStorage from '@resources/js/hooks/useLocalStorage';

export type BuildsAdvancedSettingsViewModel = {
  title: string;
  whatsThisLabel: string;
  compactLayoutSetting: {
    label: string;
    description: string;
  };
  showThroughputSetting: {
    label: string;
    description: string;
  } | null;
};

export default function BuildsAdvancedSettings({
  title,
  whatsThisLabel,
  compactLayoutSetting,
  showThroughputSetting,
}: BuildsAdvancedSettingsViewModel): JSX.Element {
  const { hiddenColumns, setHiddenColumns } = useTableHiddenColumns();
  const isCompactLocalStorageKey = 'buildsPageIsCompact';
  const [isCompact, setIsCompact] = useLocalStorage(
    isCompactLocalStorageKey,
    false
  );
  useEffect(() => {
    const element = window?.document?.querySelector('.builds-page__content');
    if (!element) {
      return;
    }
    if (isCompact) {
      element.classList.add('builds-page__content--compact');
    } else {
      element.classList.remove('builds-page__content--compact');
    }
  }, [isCompact]);

  return (
    <VerticalContent className={'builds-advanced-settings'}>
      <Heading level={2}>{title}</Heading>
      <Body>
        <VerticalContent>
          <HorizontalContent gap={'large'}>
            <label>
              <HorizontalContent>
                <Toggle
                  checked={isCompact}
                  onChange={(event) =>
                    setIsCompact(Boolean(event.target.checked))
                  }
                />
                <strong>{compactLayoutSetting.label}</strong>
              </HorizontalContent>
            </label>
            <Tooltip
              content={<p>{compactLayoutSetting.description}</p>}
              tooltipClassName={'builds-advanced-settings__tooltip'}
              zIndex={3}
            >
              <span className={'builds-advanced-settings__whats-this'}>
                {whatsThisLabel}
              </span>
            </Tooltip>
          </HorizontalContent>
          {showThroughputSetting && (
            <HorizontalContent gap={'large'}>
              <label>
                <HorizontalContent>
                  <Toggle
                    checked={hiddenColumns.length === 0}
                    onChange={(event) => {
                      if (event.target.checked) {
                        setHiddenColumns([]);
                      } else {
                        setHiddenColumns(['dps', 'hps']);
                      }
                    }}
                  />
                  <strong>{showThroughputSetting.label}</strong>
                </HorizontalContent>
              </label>
              <Tooltip
                content={<p>{showThroughputSetting.description}</p>}
                tooltipClassName={'builds-advanced-settings__tooltip'}
                zIndex={3}
              >
                <span className={'builds-advanced-settings__whats-this'}>
                  {whatsThisLabel}
                </span>
              </Tooltip>
            </HorizontalContent>
          )}
        </VerticalContent>
      </Body>
    </VerticalContent>
  );
}
